<sfx-toolbar enableDivider>
    <span translate>Regional settings</span>
</sfx-toolbar>
<sfx-content>
    <sfx-header>
        <span translate>Personal settings</span>
    </sfx-header>
    <sfx-section>
        <form #personalSettingsForm="ngForm" id="personalSettingsForm" name="personalSettingsForm" data-flex data-layout="column">
            <mat-form-field *ngIf="showTheme()">
                <mat-label translate>Theme</mat-label>
                <mat-select name="theme" data-layout="row" class="ellipsis" [(ngModel)]="theme" (ngModelChange)="savePersonalSettings()">
                    <mat-option value="system"><span translate>System</span></mat-option>
                    <mat-option value="light"><span translate>Light</span></mat-option>
                    <mat-option value="dark"><span translate>Dark</span></mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="showMultipleLanguages()">
                <mat-label translate>Language</mat-label>
                <mat-select name="language" data-layout="row" class="ellipsis" [(ngModel)]="language" (ngModelChange)="savePersonalSettings()">
                    <mat-select-trigger>
                        <span class="flag-emoji">{{ getLanguageDisplay(language)?.flag }}</span> {{ getLanguageDisplay(language)?.name }}
                    </mat-select-trigger>
                    <mat-option value="en"><span class="flag-emoji">🇺🇸</span> English</mat-option>
                    <mat-option value="fr"><span class="flag-emoji">🇫🇷</span> Français</mat-option>
                    <mat-option value="de"><span class="flag-emoji">🇩🇪</span> Deutsch</mat-option>
                    <mat-option value="it"><span class="flag-emoji">🇮🇹</span> Italiano</mat-option>
                    <mat-option value="es"><span class="flag-emoji">🇪🇸</span> Español</mat-option>
                    <mat-option value="nl"><span class="flag-emoji">🇳🇱</span> Nederlands</mat-option>
                    <mat-option value="br"><span class="flag-emoji">🇧🇷</span> Português (Brasil)</mat-option>
                    <mat-option value="pt"><span class="flag-emoji">🇵🇹</span> Português (Portugal)</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field [hidden]="!timeNotations">
                <mat-label translate>Time format</mat-label>
                <mat-select name="ampmNotation" data-layout="row" class="ellipsis" [(ngModel)]="ampmNotation" (ngModelChange)="savePersonalSettings()">
                    <mat-option *ngFor="let timeNotation of timeNotations" [value]="timeNotation">{{ getTimeNotationText(timeNotation) }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field [hidden]="!startDays">
                <mat-label translate>Week starts on</mat-label>
                <mat-select name="firstDayOfWeek" data-layout="row" class="ellipsis" [(ngModel)]="firstDayOfWeek" (ngModelChange)="savePersonalSettings()">
                    <mat-option *ngFor="let startDay of startDays" [value]="startDay">{{ getStartDayText(startDay) }}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </sfx-section>
    <ng-container *ngIf="modelService.me?.is_admin">
        <sfx-header>
            <span translate>Team settings</span>
        </sfx-header>
        <sfx-section *ngIf="modelService.me?.is_admin">
            <form #teamSettingsForm="ngForm" id="teamSettingsForm" name="teamSettingsForm" data-flex data-layout="column">
                <mat-form-field [hidden]="!timeZones">
                    <mat-label translate>Time zone</mat-label>
                    <mat-select name="timeZone" data-layout="row" class="ellipsis" [(ngModel)]="timeZone" (ngModelChange)="saveTimeZone()">
                        <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone">{{ timeZone.text }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [hidden]="!currencies">
                    <mat-label translate>Currency</mat-label>
                    <mat-select name="currency" data-layout="row" class="ellipsis" [(ngModel)]="currency" (ngModelChange)="saveCurrency()" [compareWith]="compareCurrencies">
                        <mat-select-trigger>
                            <div class="currency-flag currency-flag-{{ currency.iso | lowercase}}"></div>
                            <span class="currency-iso">{{currency.iso}}</span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let currency of currencies" [value]="currency">
                            <div class="currency-flag currency-flag-{{currency.iso | lowercase}}"></div>
                            <span class="currency-iso">{{currency.iso}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </sfx-section>
    </ng-container>
</sfx-content>
